<template>
  <v-alert
    text
    :type="type"
    :icon="icons[type]"
    :max-width="maxWidth"
    class="mx-auto"
  >
    <slot />
  </v-alert>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      type: {
        type: String,
        required: false,
        default: 'info',
      },
      maxWidth: {
        type: [Number, String],
        required: false,
        default: 480,
      },
    },
  }
</script>
